import React, { useState } from "react";
import { pxToRem, toNumberFixed } from "@/util/common";
import { createUseStyles } from "react-jss";
import { EyeInvisibleOutline, EyeOutline } from "antd-mobile-icons";
import useCustomStyles from "@/hooks/useCustomStyles";
import { Button, Grid, Image, Skeleton } from "antd-mobile";
import useCenterPopup from "@/hooks/useCenterPopup";
import InvitationCode from "./InvitationCode";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "@/redux/store";
import { isEmpty } from "lodash";
import { postApiFinanceBalance } from "@/redux/reducers/authSlice";
import useDeposit from "@/hooks/useDeposit";
import useWithdraw from "@/hooks/useWithdraw";
import TransactionPopup from "@/components/transcationPopup";
import useCustomTranslation from "@/hooks/useTranslation";
import useRouter from "@/hooks/useRouter";

const AuthorityNo: React.FC = () => {
	const classes = useStyles();
	const useClasses = useCustomStyles();
	const { t } = useCustomTranslation();
	const dispatch: AppDispatch = useDispatch();
	const { customNavigate } = useRouter();
	const { balance } = useSelector((state: RootState) => state.auth);
	const { dataList: appConfig } = useSelector(
		(state: RootState) => state.config
	);
	const ApplyCenterPopup = useCenterPopup();
	const [isRefresh, setIsRefresh] = useState(false);
	const [balanceHidden, setBalanceHidden] = useState(false);
	const {
		prepareDeposit,
		submitDeposit,
		depositReady,
		depositParams,
		cancelDeposit,
	} = useDeposit(2);
	const {
		prepareWithdraw,
		submitWithdraw,
		cancelWithdraw,
		withdrawReady,
		withdrawParams,
	} = useWithdraw(2);

	const postApiFinanceBalanceHandle = async () => {
		setIsRefresh(true);
		await dispatch(postApiFinanceBalance({}));
		setTimeout(() => {
			setIsRefresh(false);
		}, 2000);
	};

	const toggleAmountDisplay = () => {
		if (balanceHidden) {
			setBalanceHidden(false);
		} else {
			setBalanceHidden(true);
		}
	};

	const applyForStartingHandle = () => {
		const activeValue: number = appConfig?.home.active ?? 0;
		// if (isEmpty(balance) || balance["2"] < activeValue) {
		// 	return Toast.show({
		// 		content: `Please recharge ${toNumberFixed(
		// 			activeValue,
		// 			2
		// 		)} KDto activate the service`,
		// 		position: "top",
		// 	});
		// }
		ApplyCenterPopup.showPopup();
	};

	return (
		<div className={classes.authorityNoWrap}>
			<div
				className={`${useClasses.cardWrap} ${classes.authCard}`}
				style={{ marginBottom: pxToRem(10) }}
			>
				<div className="lockValue">{t("OrderLockValue")}</div>
				<div className="progress">0%</div>
				<div onClick={toggleAmountDisplay} className="eye">
					<span>{t("Vault")}</span>
					{balanceHidden ? (
						<EyeInvisibleOutline color="#868FA8" fontSize={16} />
					) : (
						<EyeOutline color="#868FA8" fontSize={16} />
					)}
				</div>
				<h1>
					{!isEmpty(balance) ? (
						balanceHidden ? (
							"*****"
						) : (
							toNumberFixed(balance["2"], 2)
						)
					) : (
						<Skeleton
							animated
							style={{
								height: pxToRem(44),
								width: "50%",
								margin: "0 auto",
							}}
						/>
					)}
				</h1>
				<div className={classes.buttonsWrap}>
					<Grid columns={2} gap={[15, 0]}>
						<Grid.Item>
							<Button
								block
								shape="rounded"
								fill="outline"
								style={{
									fontSize: pxToRem(14),
									fontWeight: "400",
									"--text-color": "#82E8FF",
									"--background-color": "transparent",
									"--border-color": "#4C66C7",
								}}
								onClick={() => {
									customNavigate("/wallet/2/0");
								}}
							>
								{t("Deposit")}
							</Button>
						</Grid.Item>
						<Grid.Item>
							<Button
								block
								shape="rounded"
								fill="outline"
								style={{
									fontSize: pxToRem(14),
									fontWeight: "400",
									"--text-color": "#82E8FF",
									"--background-color": "transparent",
									"--border-color": "#4C66C7",
								}}
								onClick={() => {
									customNavigate("/wallet/2/1");
								}}
							>
								{t("Withdraw")}
							</Button>
						</Grid.Item>
					</Grid>
				</div>
				<Image
					onClick={postApiFinanceBalanceHandle}
					className={`iRefresh ${isRefresh ? "refresh" : ""}`}
					src={require("@/assets/images/icons/refresh.png")}
					width={20}
					height={20}
				/>
			</div>

			<div className={`${useClasses.cardWrap} ${classes.authCard}`}>
				<div className="describe">
					{appConfig?.agent.applyBalance &&
					appConfig?.agent.applyBalance > 0 ? (
						<>
							<p>{t("PleaseRecharge")}</p>
							<p className="white">
								{toNumberFixed(
									appConfig?.agent.applyBalance,
									2
								)}{" "}
								USDT
							</p>
						</>
					) : null}
					<p>{t("ActivateService")}</p>
				</div>
				<Button
					onClick={applyForStartingHandle}
					block
					shape="rounded"
					style={{
						height: pxToRem(50),
						fontSize: pxToRem(16),
						fontWeight: "700",
						"--border-width": "0",
						"--text-color": "#FFFFFF",
						background:
							" linear-gradient(90deg, #4675FF 0%, #0E329D 100%)",
					}}
				>
					{t("ApplyStarting")}
				</Button>
			</div>
			<ApplyCenterPopup.PopupComp
				visible={ApplyCenterPopup.visiblePopup}
				onClose={ApplyCenterPopup.closePopup}
				bodyStyle={{ background: "transparent" }}
				onMaskClick={() => {
					ApplyCenterPopup.closePopup();
				}}
				className="centerPopupAfoot"
				style={{ "--max-width": "100vw" }}
			>
				<InvitationCode onVisiblePopup={ApplyCenterPopup.closePopup} />
			</ApplyCenterPopup.PopupComp>

			<TransactionPopup
				visible={withdrawReady}
				type={"withdraw"}
				{...withdrawParams}
				onClose={() => {
					cancelWithdraw();
				}}
				onSubmit={(_, params) => {
					return submitWithdraw(params);
				}}
			/>

			<TransactionPopup
				visible={depositReady}
				type={"deposit"}
				{...depositParams}
				onClose={() => {
					cancelDeposit();
				}}
				onSubmit={(type, params) => {
					return submitDeposit();
				}}
			/>
		</div>
	);
};

export default AuthorityNo;

const useStyles = createUseStyles({
	authorityNoWrap: {
		marginTop: pxToRem(22),
	},
	authCard: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		position: "relative",
		padding: {
			top: pxToRem(40),
			bottom: pxToRem(15),
			left: pxToRem(20),
			right: pxToRem(20),
		},
		"& .lockValue": {
			color: "#76819F",
			fontSize: pxToRem(13),
			fontWeight: 500,
			fontFamily: "Barlow",
			textAlign: "center",
			marginBottom: pxToRem(3),
		},
		"& .progress": {
			color: "#FFE380",
			fontSize: pxToRem(33),
			fontWeight: 700,
			fontFamily: "Barlow",
			textAlign: "center",
			lineHeight: pxToRem(48),
			letterSpacing: "1px",
		},
		"& .eye": {
			color: "#868FA8",
			fontSize: pxToRem(14),
			fontWeight: "400",
			lineHeight: pxToRem(22),
			textAlign: "center",
			"& span": {
				paddingRight: pxToRem(4),
			},
		},
		"& h1": {
			color: "#FFFFFF",
			fontSize: pxToRem(28),
			fontWeight: 700,
			lineHeight: pxToRem(34),
			textAlign: "center",
		},
		"& .iRefresh": {
			position: "absolute",
			top: pxToRem(16),
			right: pxToRem(20),
		},
		"& .describe": {
			color: "#82E8FF",
			fontSize: pxToRem(18),
			fontWeight: "600",
			lineHeight: pxToRem(28),
			textAlign: "center",
			"& .white": {
				color: "#FFFFFF",
			},
			paddingBottom: pxToRem(20),
		},
	},
	buttonsWrap: {
		padding: {
			top: pxToRem(18),
		},
	},
});
